(function (angular) {
  "use strict";

  angular.module("app").provider("Stripe", StripeProvider as any);

  StripeProvider.$inject = ["$httpProvider"];

  function StripeProvider($httpProvider) {
    this.$get = [
      "$http",
      function ($http) {
        return $http
          .get("/api/stripe")
          .then(function (response) {
            if (response.data && response.data.stripeKey) {
              return response.data.stripeKey;
            } else {
              throw new Error("Invalid response from /api/stripe");
            }
          })
          .catch(function (error) {
            console.error("Error fetching stripe key:", error);
            throw error;
          });
      },
    ];
  }
})(angular);
